import { render, staticRenderFns } from "./CreateEditNote.vue?vue&type=template&id=6a1cee3c&scoped=true&"
import script from "./CreateEditNote.vue?vue&type=script&lang=ts&"
export * from "./CreateEditNote.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEditNote.vue?vue&type=style&index=0&id=6a1cee3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1cee3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VRadio,VRadioGroup})
